/**
 * Events emitted by the UI.
 *
 * @remarks
 * Events can be subscribed to with `player.addEventListener()`.
 */
export const UIEvent = {
  /**
   * The next medium should be loaded.
   *
   * @remarks
   * This event can be emitted either by user interaction or by a feature which
   * is meant to automatically play another medium after the currently active one finished.
   *
   * If you activated features which emit this event, you as the integrator should make
   * sure that the event gets handled properly. Otherwise, the user shows that he wants
   * to see another video but nothing would happen.
   */
  NextMediumRequest: 'ui:NextMediumRequest',

  /**
   * When the experimental feature {@link UIConfig.experimental.fullscreenEventsOnly}
   * is activated, a click on the fullscreen button will only emit this event.
   */
  EnterFullscreenRequest: 'ui:EnterFullscreenRequest',

  /**
   * When the experimental feature {@link UIConfig.experimental.fullscreenEventsOnly}
   * is activated, a click on the exit-fullscreen button will only emit this event.
   */
  ExitFullscreenRequest: 'ui:ExitFullscreenRequest',
} as const;

/**
 * The events emitted by the UI mapped to their type.
 */
export type UIEventMap = {
  [UIEvent.NextMediumRequest]: Event;
  [UIEvent.EnterFullscreenRequest]: Event;
  [UIEvent.ExitFullscreenRequest]: Event;
};
